import { LAUNCHER_TYPES } from '@/domain/launcherTypes';
import type { V2Launcher } from '@/launchers/types';

// CHAT_BAR is a singleton: sanitizeLaunchers keeps only the first entry, so the first match is the org's one.
export function findChatBarLauncher(launchers: readonly V2Launcher[] | undefined): V2Launcher | undefined {
  return launchers?.find((launcher) => launcher.type === LAUNCHER_TYPES.CHAT_BAR);
}
